export const SIDEBAR_COLORS = {
  textPrimary: '#0A1E28',
  textSecondary: '#667A86'
} as const;
